var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid mb-2 mb-md-3" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", {
            staticClass: "h2",
            domProps: { innerHTML: _vm._s(_vm.advantagesTitle) },
          }),
        ]),
        _vm._v(" "),
        _vm._l(_vm.advantagesList, function (advantage, advantageIndex) {
          return _c(
            "div",
            {
              key:
                "advantage_" +
                (advantage.icon ? advantage.icon : "") +
                "_" +
                advantageIndex,
              staticClass: "col-12 col-lg-4",
            },
            [
              _c("div", { staticClass: "alert-container h-100 px-0 mb-0" }, [
                _c("p", { staticClass: "alert" }, [
                  _c("span", {
                    staticClass: "alert-icon",
                    class: [advantage.icon],
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(advantage.title) },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "alert-content" }, [
                  _c("p", {
                    staticClass: "alert-text",
                    domProps: { innerHTML: _vm._s(advantage.text) },
                  }),
                ]),
              ]),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }